export const ApiEndpoints = {
  ConfigurationsApi: {
    GetAllConfigurations: '/configuration/configurations',
    GetGoogleAPIConfigurations: '/configuration/configuration/',
    GetCustomerConfigurationsByClientId:
      '/configuration/client-configurations/',
  },
  Identity: {
    Authenticate: '/identity/authenticate',
    CustomerLogin: '/identity/customer-login',
    CustomersLoginUsingSSo: '/identity/customers-login-using-sso',
    DriverLogin: '/identity/driver-login',
    CheckIfEmailExist: '/identity/check-existing-email/',
    Logout: '/identity/logout',
    SendVerificationCodeForResetPassword:
      '/identity/reset-password-verification',
    ValidateVerificationCodeForResetPassword:
      '/identity/reset-password-validation',
    ResetPassword: '/identity/reset-password',
    VerifyDriverLocation: 'drivers/verify-driver-location',
  },

  DriverAlerts: {
    GetAllDriverAlerts: '/driver-alerts/driver-alerts',
    UpdateStatusDriverAlert: '/driver-alerts/update-driver-alert/',
    AddDriverAlert: '/driver-alerts/add',
    UpdateDriverAlertStatusOnFireStore:
      '/driver-alerts/update-firestore-driver-alert',
  },
  Conversations: {
    OpenNewConversation: '/OpenNewConversation',
    customtoken: '/custom-token',
  },
  Messages: {
    SendMessage: '/messages/send',
    CreateMessageForMobile: '/messages/mobile',
  },
  IncidentReport: {
    GetAllIncidentReport: '/incident-report/reports',
    GetAllIncidentReportByCustomerId: '/incident-report/customer-reports',
    GetIncidentReportById: '/incident-report/report/',
    AddIncidentReport: '/incident-report/add-report',
    PostIncidentReport: '/incident-report/add-report',
    EditIncidentReport: '/incident-report/edit-report',
    UpdateStatusIncidentReport: '/incident-report/status-report/',
    GetAllIncidentReportActivityLog: '/incident-report/report-activity-log',
    AddIncidentReportNote: '/incident-report/report-note',
    GetAllIncidentReportNotes: '/incident-report/report-notes',
    GetIncidentReportInfo: '/incident-report/report-info/',
    SendIncidentReportExternalEmail: '/incident-report/email-report/',
    AssignIncidentReportToDispatcher: '/incident-report/assign-incident/',
  },
  TaskTracking: {
    GetAllTaskTracking: '/task-tracking/get-driver-tasks-By-id',
    AddTaskDriverCheckin: '/task-tracking/add-task-driver-check-in',
    AddTaskDriverCheckout: '/task-tracking/add-task-driver-check-out',
    GetCheckoutReasons: '/task-tracking/get-all-check-out-reasons',
    UpdateDriverTask: '/task-tracking/update-driver-task',
    VehiclesList: '/vehicles/vehicles-list',
    RoutesList: '/route/get-all-routes-without-tasks-for-drop-down-list',
    GetUpcomingTaskCount: '/task-tracking/get-count-driver-tasks-By-id',
  },

  CommonApis: {
    GetAllRegionsLocationsRolesTogether: '/common/regions-with-roles',
    GetAllRegions: '/common/regions',
    GetAllLocations: '/common/locations',
    GetAllSchoolsCustomers: '/common/school-customers/',
    GetAllSchools: '/common/schools/',
    GetAllSchoolsWithoutCustomer: '/common/get-all-schools-without-customer/',
    GetAllSchoolsNotSelectedByCustomer:
      '/common/get-all-schools-not-selected-by-customer/',
    GetAllCustomers: '/common/customers/',
    GetAllRegionsLocationsTogether: '/common/regions-locations',
    GetAllSchoolsByCustomer: '/common/customer-schools/',
    ChangeNotificationsStatus: '/common/change-notifications-status/',
    GetAllStudentsBySchool: '/common/students/',
    GetSpecificConfigration: '/common/get-specific-configration/',
    GetAllRoles: '/common/roles/',
    GetUserCustomers: '/common/user-customers',
    GetVehiclesForDropDownLists: '/common/vehicles-lists',
    GetGoogleTimeZone: '/common/google-timezone',
    GetAddressByGoogleGeoCode: '/common/address-google-geo-code',
    GetKioskAddressByGoogleGeoCode: '/kiosk/get-address-by-google-geo-code',
  },
  Customer: {
    GetAllDistrictsByLocationIds: '/customers/districts'
  },
};
